<template lang="pug">
  y-dialog(v-model="dialog" width="600px" persistent)
    v-card
      v-card-title {{ $t('subscribe_later_faq') }}
      v-card-text.px-4
        v-expansion-panels.my-4(tile)
          v-expansion-panel
            v-expansion-panel-header {{ $t('what_happen_subscribe_later') }}
            v-expansion-panel-content
        v-row
          v-col.py-0(cols="12")
            v-btn.body-2(color="accent" block depressed @click="continueLater") {{ $t('i_understand_subscribe') }}
          v-col.pb-0.pt-2(cols="12")
            v-btn.body-2(color="primary" block depressed @click="dialog=false") {{ $t('return_to_subscription') }}
</template>

<script>
  import { mapActions } from 'vuex'
  
  export default {
    name: "SubscribeLaterModal",
    props: ['value'],
    data: () => ({
      step: 0,
      steps: [
        { title: 'Choose Plan'}
      ]
    }),
    computed: {
      dialog: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      },
      windowTitle () {
        return this.steps[this.step].title
      }
    },
    methods: {
      ...mapActions([
        'showMessage'
      ]),
      continueLater () {
        this.dialog = false
        this.$emit('continueLater')
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>

<i18n>
{
  "en": {
    "subscribe_later_faq": "Subscribe later FAQ and agreement",
    "what_happen_subscribe_later": "What happen if I subscribe later?",
    "i_understand_subscribe": "I understand, subscribe later"
  },
  "id": {
    "subscribe_later_faq": "Berlangganan nanti FAQ dan persetujuan",
    "what_happen_subscribe_later": "Apa yang terjadi jika saya berlangganan nanti?",
    "i_understand_subscribe": "Saya mengerti, berlangganan nanti"
  }
}
</i18n>